(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockVorversicherung', {
            bindings: {
                form: '<abvForm',
                vorversicherung: '=abvVorversicherung',
                title: '@abvTitle',
                labelVorversicherungVorhanden: '@abvLabelVorversicherungVorhanden',
                labelGueltigFuerGegenstand: '@abvLabelGueltigFuerGegenstand',
                labelVersicherungsnummer: '@abvLabelVersicherungsnummer',
                labelVersicherungsnummerTooltip: '@abvLabelVersicherungsnummerTooltip',
                produktNummer: '<abvProduktNummer',
                kompatibleProdukte: '<abvKompatibleProdukte',
                subtypenBeachten: '<abvSubtypenBeachten',
                options: '<abvOptions'
            },
            transclude: {
                hinweisAllgemein: '?abvHinweisAllgemein',
                vorversicherungVorhandenTooltip: '?abvVorversicherungVorhandenTooltip',
                vorversicherungGesellschaftTooltip: '?abvVorversicherungGesellschaftTooltip'
            },
            templateUrl: 'bloecke/vorversicherung/blockVorversicherung.html',
            controller: BlockVorversicherungController,
            controllerAs: 'vorversicherungVm'
        });

    BlockVorversicherungController.$inject = [
        '$scope',
        '$filter',
        '$transclude',
        'lodash',
        'moment',
        'AppConfig',
        'AngebotModel',
        'BasisAngebotService',
        'FormFieldUtilsService',
        'MiscUtilsService',
        'SchluesselWerteUtilsService'
    ];
    function BlockVorversicherungController($scope, $filter, $transclude, _, moment, AppConfig, AngebotModel, BasisAngebotService, FormFieldUtilsService, MiscUtilsService, SchluesselWerteUtilsService) {
        var vm = this,
            formFieldNames = [
                'vorhanden',
                'beiWemBestandVorversicherung',
                'versicherungsunternehmen',
                'unternehmenVersicherungsscheinnummer',
                'fremdgesellschaftVersicherungsscheinnummer',
                'ablaufdatumDerVorversicherung',
                'wurdeVertragGekuendigt',
                'wurdeVertragGekuendigtVomVu',
                'gueltigFuerGegenstand',
                'vorversicherungsdauer',
                'umschreibungsgrund'
            ],
            VERSICHERUNGSGESELLSCHAFT_WGV_HIMMELBLAU = BasisAngebotService.getConstant('versicherungsgesellschaften').wgvHimmelblau;

        vm.$onInit = onInit;
        vm.$doCheck = doCheck;
        vm.$onChanges = onChanges;
        vm.resetValue = resetValue;

        vm.onVorversicherungVorhandenChanged = onVorversicherungVorhandenChanged;
        vm.onVersicherungsunternehmenChanged = onVersicherungsunternehmenChanged;
        vm.isFieldDisabled = isFieldDisabled;
        vm.isInfoErlaubt = isInfoErlaubt;
        vm.isVorversicherungVorhandenErlaubt = isVorversicherungVorhandenErlaubt;
        vm.isVorversicherungNurFremdversicherung = isVorversicherungNurFremdversicherung;
        vm.isBeiWemBestandVorversicherungErlaubt = isBeiWemBestandVorversicherungErlaubt;
        vm.isBeiWemBestandVorversicherungGesellschaftErlaubt = isBeiWemBestandVorversicherungGesellschaftErlaubt;
        vm.isUnternehmenVersicherungsscheinnummerErlaubt = isUnternehmenVersicherungsscheinnummerErlaubt;
        vm.isFremdgesellschaftVersicherungsscheinnummerErlaubt = isFremdgesellschaftVersicherungsscheinnummerErlaubt;
        vm.isAblaufdatumDerVorversicherungErlaubt = isAblaufdatumDerVorversicherungErlaubt;
        vm.isWurdeVertragGekuendigtErlaubt = isWurdeVertragGekuendigtErlaubt;
        vm.isWurdeVertragGekuendigtVomVuErlaubt = isWurdeVertragGekuendigtVomVuErlaubt;
        vm.isHinweisVorversicherungGekuendigtVomVuSichtbar = isHinweisVorversicherungGekuendigtVomVuSichtbar;
        vm.isLinkMusterrechnungSichtbar = isLinkMusterrechnungSichtbar;
        vm.isGueltigFuerGegenstandErlaubt = isGueltigFuerGegenstandErlaubt;
        vm.isVorversicherungsdauerErlaubt = isVorversicherungsdauerErlaubt;
        vm.isUmschreibungsgrundErlaubt = isUmschreibungsgrundErlaubt;
        vm.resetKuendigungsdaten = resetKuendigungsdaten;

        function activate() {
            vm.options = vm.options || {};
            vm.optionsInitial = _.cloneDeep(vm.options);
            vm.options.disabled = vm.options.disabled || {};

            vm.angebotModel = AngebotModel.get();

            vm.uuid = MiscUtilsService.guid('#');
            vm.hasTooltipVorversicherungGesellschaft = $transclude.isSlotFilled('vorversicherungGesellschaftTooltip');
            vm.hasTooltipVorversicherungVorhanden = $transclude.isSlotFilled('vorversicherungVorhandenTooltip');
            vm.vorverdauerSw = SchluesselWerteUtilsService.getSchluesselwert('vorverdauer');
            vm.umschreibungsgrundSw = SchluesselWerteUtilsService.getSchluesselwert('umschreibungsgrund');
            vm.versicherungsunternehmenSw = SchluesselWerteUtilsService.getSchluesselwert('versicherungsunternehmen');
            vm.vorversicherungGekuendigtVon = BasisAngebotService.getConstant('vorversicherungGekuendigtVon', vm.angebotModel.angebot);
            vm.currentDateMinus120yearsYYYYMMDD = moment().subtract(120, 'years').format(AppConfig.API.dateFormat);
            vm.currentDatePlus10yearsYYYYMMDD = moment().add(10, 'years').format(AppConfig.API.dateFormat);

            vm.labelGueltigFuerGegenstand = vm.labelGueltigFuerGegenstand || 'Soll diese nur noch für den oben genannten Versicherungsort gelten?';
            vm.labelVersicherungsnummer = vm.labelVersicherungsnummer || 'Versicherungsnummer';
            vm.labelVersicherungsnummerTooltip = vm.labelVersicherungsnummerTooltip || 'Wo finde ich meine Versicherungsnummer?';

            vm.CONSTANTS = {
                vorversicherungUnternehmen: BasisAngebotService.getConstant('vorversicherungsarten.unternehmen', vm.angebotModel.angebot),
                vorversicherungFremdversicherung: BasisAngebotService.getConstant('vorversicherungsarten.fremdversicherung', vm.angebotModel.angebot),
                vorversicherungGekuendigtVonVersicherer: vm.vorversicherungGekuendigtVon.versicherer,
                vorversicherungGekuendigtVonVersicherungsnehmer: vm.vorversicherungGekuendigtVon.versicherungsnehmer
            };

            vm.typeaheadVersicherungsunternehmenOptions = {
                displayTemplate: '<%= data.bezeichnung %>',
                trackByProperty: 'wert',
                trackingName: 'vorversicherung' + (vm.options.trackingNameSuffix || '') + '_vu_liste',
                trackingWithValue: true,
                validation: {
                    showMessageOnValidate: true
                }
            };

            vm.formFieldNames = _.zipObject(formFieldNames, _.map(formFieldNames, function (fieldName) {
                return [
                    fieldName,
                    vm.uuid
                ].join('_');
            }));

            if (isVorversicherungsdauerErlaubt() && !vm.vorverdauerSw) {
                vm.vorverdauerSw = SchluesselWerteUtilsService.getSchluesselwert('vorverdauer');

                if (!vm.vorverdauerSw) {
                    SchluesselWerteUtilsService.fetch('vorverdauer', {
                        params: {
                            sort: 'sortierKz'
                        }
                    }).then(function (vorverdauer) {
                        vm.vorverdauerSw = vorverdauer;
                    });
                }
            }

            if (!isVorversicherungVorhandenErlaubt()) {
                _.set(vm, 'vorversicherung.vorhanden', true);
            }

            if (!isBeiWemBestandVorversicherungErlaubt() && !vm.isFieldDisabled('beiWemBestandVorversicherung')) {
                if (vm.options.beiWemBestandVorversicherung !== _.get(vm, 'vorversicherung.beiWemBestandVorversicherung')) {
                    _.set(vm, 'vorversicherung.beiWemBestandVorversicherungGesellschaft', null);
                    _.set(vm, 'vorversicherung.unternehmenVersicherungsscheinnummer', null);
                    _.set(vm, 'vorversicherung.fremdgesellschaftVersicherungsscheinnummer', null);
                }

                _.set(vm, 'vorversicherung.beiWemBestandVorversicherung', vm.options.beiWemBestandVorversicherung || null);
            }

            MiscUtilsService.setDefaultValueIfEmpty(vm.vorversicherung, 'beiWemBestandVorversicherung', vm.options.beiWemBestandVorversicherung || null);

            vm.linkMusterrechnung = AppConfig.ANGEBOT.links.musterrechnung;
            vm.placeholders = {
                ablaufdatumDerVorversicherung: {
                    'min, max': [
                        $filter('date')(moment().subtract(120, 'years').format(AppConfig.API.dateFormat), 'dd.MM.yyyy'),
                        $filter('date')(moment().add(10, 'years').format(AppConfig.API.dateFormat), 'dd.MM.yyyy')
                    ]
                },
                fremdgesellschaftVersicherungsscheinnummer: {
                    maxlength: [
                        _.get(vm.options, 'validations.fremdgesellschaftVersicherungsscheinnummer.maxlength', 30)
                    ]
                }
            };

            handleProduktnummer();
        }

        function onInit() {
            activate();
        }

        function doCheck() {
            resetModelValues();
        }

        function onChanges(changes) {
            var produktNummerChanges = changes.produktNummer;

            if (produktNummerChanges && !produktNummerChanges.isFirstChange() && produktNummerChanges.currentValue !== produktNummerChanges.previousValue) {
                handleProduktnummer();
            }

            activate();
        }

        function onVorversicherungVorhandenChanged(vorversicherungVorhanden) {
            if (vorversicherungVorhanden === false) {
                _.set(vm, 'vorversicherung.fremdgesellschaftVersicherungsscheinnummer', null);
                _.set(vm, 'vorversicherung.beiWemBestandVorversicherung', null);
                _.set(vm, 'vorversicherung.beiWemBestandVorversicherungGesellschaft', null);
            } else if (vorversicherungVorhanden === true) {
                _.set(vm, 'vorversicherung.beiWemBestandVorversicherung', vm.options.beiWemBestandVorversicherung || null);
            }

        }
        function resetValue(modelExpression, value) {
            FormFieldUtilsService.resetValue($scope, modelExpression, value);
        }
        function resetModelValues() {
            if (!isAblaufdatumDerVorversicherungErlaubt() && _.get(vm.options, 'showAblaufdatumDerVorversicherung') !== false) {
                _.set(vm, 'vorversicherung.ablaufdatumDerVorversicherung', null);
            }

            if (!isWurdeVertragGekuendigtErlaubt() && _.get(vm.options, 'showWurdeVertragGekuendigt') !== false) {
                _.set(vm, 'vorversicherung.wurdeVertragGekuendigt', null);
            }

            if (!isGueltigFuerGegenstandErlaubt()) {
                _.set(vm, 'vorversicherung.gueltigFuerRisikoadresse', null);
            }

            if (!isUnternehmenVersicherungsscheinnummerErlaubt()) {
                _.set(vm, 'vorversicherung.unternehmenVersicherungsscheinnummer', null);
            }

            if (!isFremdgesellschaftVersicherungsscheinnummerErlaubt()) {
                _.set(vm, 'vorversicherung.fremdgesellschaftVersicherungsscheinnummer', null);
            }
        }
        function onVersicherungsunternehmenChanged(value) {
            if (value) {
                if (_.get(value, 'wert') === VERSICHERUNGSGESELLSCHAFT_WGV_HIMMELBLAU) {
                    _.set(vm.vorversicherung, 'beiWemBestandVorversicherung', _.get(vm.CONSTANTS, 'vorversicherungUnternehmen.wert'));
                } else {
                    _.set(vm.vorversicherung, 'beiWemBestandVorversicherung', _.get(vm.CONSTANTS, 'vorversicherungFremdversicherung.wert'));
                }

                $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.form[vm.formFieldNames.versicherungsunternehmen], '$$element') ], {
                    force: true
                });
            }

            handleProduktnummer();
        }
        function handleProduktnummer() {
            vm.vorversicherungProduktnummer = vm.produktNummer + (_.get(vm.vorversicherung, 'beiWemBestandVorversicherungGesellschaft.wert') === VERSICHERUNGSGESELLSCHAFT_WGV_HIMMELBLAU ? 'IV' : '');
        }
        function isFieldDisabled(fieldName) {
            return (
                (
                    _.get(vm.options, 'disabled.' + fieldName) ||
                    _.get(vm.vorversicherung, 'ersatzgeschaeftRelevant') === true
                 ) &&
                MiscUtilsService.isNotEmpty(_.get(vm.vorversicherung, fieldName))
            );
        }
        function isInfoErlaubt() {
            return (
                _.get(vm.options, 'showInfo') !== false &&
                ((
                    vm.isFieldDisabled('beiWemBestandVorversicherung') &&
                    _.get(vm.vorversicherung, 'beiWemBestandVorversicherung') !== _.get(vm.CONSTANTS, 'vorversicherungUnternehmen.wert')
                ) || (
                    !vm.isFieldDisabled('beiWemBestandVorversicherung')
                ))
            );
        }
        function isVorversicherungVorhandenErlaubt() {
            return _.get(vm.options, 'showVorversicherungVorhanden') !== false;
        }
        function isVorversicherungNurFremdversicherung() {
            return _.get(vm.options, 'vorversicherungNurFremdversicherung') === true;
        }
        function isBeiWemBestandVorversicherungErlaubt() {
            return (
                _.get(vm.options, 'showBeiWemBestandVorversicherung') !== false &&
                _.get(vm.vorversicherung, 'ersatzgeschaeftRelevant') !== true
            );
        }
        function isBeiWemBestandVorversicherungGesellschaftErlaubt() {
            return (
                (
                    _.get(vm.vorversicherung, 'beiWemBestandVorversicherung') === _.get(vm.CONSTANTS, 'vorversicherungFremdversicherung.wert') ||
                    _.get(vm.vorversicherung, 'beiWemBestandVorversicherungGesellschaft.wert') === VERSICHERUNGSGESELLSCHAFT_WGV_HIMMELBLAU
                ) &&
                _.get(vm.options, 'showBeiWemBestandVorversicherungGesellschaft') !== false
            );
        }
        function isUnternehmenVersicherungsscheinnummerErlaubt() {
            return (
                _.get(vm.vorversicherung, 'vorhanden') === true && (
                    _.get(vm.vorversicherung, 'beiWemBestandVorversicherung') === _.get(vm.CONSTANTS, 'vorversicherungUnternehmen.wert') ||
                    (
                        _.get(vm.options, 'beiWemBestandVorversicherung') === _.get(vm.CONSTANTS, 'vorversicherungUnternehmen.wert') &&
                        _.get(vm.options, 'showBeiWemBestandVorversicherungGesellschaft') === false
                    )
                )
            );
        }
        function isFremdgesellschaftVersicherungsscheinnummerErlaubt() {
            return (
                _.get(vm.options, 'showFremdgesellschaftVersicherungsscheinnummer') !== false &&
                (
                    _.get(vm.vorversicherung, 'beiWemBestandVorversicherung') === _.get(vm.CONSTANTS, 'vorversicherungFremdversicherung.wert') ||
                    (
                        _.get(vm.options, 'beiWemBestandVorversicherung') === _.get(vm.CONSTANTS, 'vorversicherungFremdversicherung.wert') &&
                        _.get(vm.options, 'showBeiWemBestandVorversicherungGesellschaft') === false
                    )
                )
            );
        }
        function isAblaufdatumDerVorversicherungErlaubt() {
            return (
                _.get(vm.options, 'showAblaufdatumDerVorversicherung') !== false &&
                _.get(vm.vorversicherung, 'beiWemBestandVorversicherung') &&
                _.get(vm.vorversicherung, 'beiWemBestandVorversicherung') !== _.get(vm.CONSTANTS, 'vorversicherungUnternehmen.wert') &&
                isWurdeVertragGekuendigtErlaubt() &&
                _.get(vm.vorversicherung, 'wurdeVertragGekuendigt')
            );
        }
        function isWurdeVertragGekuendigtErlaubt() {
            return (
                _.get(vm.options, 'showWurdeVertragGekuendigt') !== false &&
                _.get(vm.vorversicherung, 'beiWemBestandVorversicherung') &&
                _.get(vm.vorversicherung, 'beiWemBestandVorversicherung') !== _.get(vm.CONSTANTS, 'vorversicherungUnternehmen.wert')
            );
        }
        function isWurdeVertragGekuendigtVomVuErlaubt() {
            return (
                isWurdeVertragGekuendigtErlaubt() &&
                _.get(vm.vorversicherung, 'wurdeVertragGekuendigt') &&
                _.get(vm.options, 'showWurdeVertragGekuendigt') !== false &&
                _.get(vm.vorversicherung, 'beiWemBestandVorversicherung') &&
                _.get(vm.vorversicherung, 'beiWemBestandVorversicherung') !== _.get(vm.CONSTANTS, 'vorversicherungUnternehmen.wert')
            );
        }
        function isHinweisVorversicherungGekuendigtVomVuSichtbar() {
            return !!_.get(vm.vorversicherung, 'wurdeVertragGekuendigtVomVu');
        }
        function isLinkMusterrechnungSichtbar() {
            return (
                !isFieldDisabled('unternehmenVersicherungsscheinnummer') &&
                !MiscUtilsService.isAppModus()
            );
        }
        function isGueltigFuerGegenstandErlaubt() {
            return _.get(vm.options, 'showGueltigFuerGegenstand');
        }
        function isVorversicherungsdauerErlaubt() {
            return (
                _.get(vm.options, 'showVorversicherungsdauer') &&
                _.get(vm.vorversicherung, 'beiWemBestandVorversicherungGesellschaft.wert') !== VERSICHERUNGSGESELLSCHAFT_WGV_HIMMELBLAU
            );
        }
        function isUmschreibungsgrundErlaubt() {
            return (
                BasisAngebotService.hasAngebotsart(AngebotModel.get().angebot, null, 'UMSCHREIBUNG') &&
                _.size(vm.umschreibungsgrundSw) > 0
            );
        }
        function resetKuendigungsdaten() {
            if (!_.get(vm.vorversicherung, 'wurdeVertragGekuendigt')) {
                _.set(vm.vorversicherung, 'ablaufdatumDerVorversicherung', null);
                _.set(vm.vorversicherung, 'wurdeVertragGekuendigtVomVu', null);
            }
        }
    }

})();
